import { Box, Typography } from "@mui/material";
import Link from "next/link";
import { type FileType } from "@utils/assets";
import { AdminModal } from "./admin-modal";
import { UploadFileButton } from "./upload-file-button";
import { useNotify } from "./notification-provider";

type Props = {
  open: boolean;
  onClose: () => void;
  constraints: {
    width: number;
    height: number;
    maxSizeKb: number;
  };
  allowedFileTypes?: FileType[];
  handleUpload: (file: File) => void;
  uploading: boolean;
};

export const UploadImageModal = ({
  open,
  onClose,
  constraints,
  allowedFileTypes,
  handleUpload,
  uploading,
}: Props) => {
  const { notify } = useNotify();
  const size = `${constraints.width}x${constraints.height}`;
  return (
    <AdminModal open={open} onClose={onClose} style={{ overflowY: "auto" }}>
      <Box
        style={{ backgroundColor: "#FFF", borderRadius: "8px" }}
        sx={{ p: 2 }}
      >
        <Typography variant="body1" gutterBottom>
          Please upload an image with the exact dimensions of {size} pixels and
          WEBP format.
        </Typography>
        <Typography variant="body1" gutterBottom>
          Follow these steps to prepare your image:
        </Typography>
        <Typography variant="body1" gutterBottom>
          1.{" "}
          <Link
            href="https://www.iloveimg.com/crop-image"
            target="_blank"
            rel="noopener noreferrer"
          >
            Crop your image
          </Link>{" "}
          to match the required aspect ratio.
        </Typography>
        <Typography variant="body1" gutterBottom>
          2.{" "}
          <Link
            href="https://www.iloveimg.com/resize-image"
            target="_blank"
            rel="noopener noreferrer"
          >
            Resize your image
          </Link>{" "}
          to {size} pixels.
        </Typography>
        <Typography variant="body1" gutterBottom>
          3.{" "}
          <Link
            href="https://cloudinary.com/tools/image-to-webp"
            target="_blank"
            rel="noopener noreferrer"
          >
            Convert to WEBP
          </Link>
          {". "}
          Dont use other online webp converters, use only cloudinary from this
          link.
        </Typography>
        <UploadFileButton
          label="Upload Image"
          onChange={handleUpload}
          uploading={uploading}
          onError={(msg) => notify({ msg, severity: "error" })}
          allowedFileTypes={allowedFileTypes}
          maxSizeKb={constraints.maxSizeKb}
          isSizeValid={({ width, height }) => {
            return width === constraints.width && height === constraints.height;
          }}
          fullWidth
        />
      </Box>
    </AdminModal>
  );
};
